import React, { useState } from 'react';
import { FiHelpCircle } from 'react-icons/fi';
import { GheIxTablesTab } from '../../components/gheIxTables/GheIxTablesTab';
import ProjectShell from '../../components/layout/ProjectShell';
import { Button, HelpWindow, gheHelpTopics } from '../../design-system';

type IconProps = { size?: number; color?: string; style?: React.CSSProperties };
const HelpIcon = FiHelpCircle as React.FC<IconProps>;

const IxTablesPage = () => {
  const [helpOpen, setHelpOpen] = useState(false);
  const helpButton = (
    <Button variant="secondary" startIcon={<HelpIcon size={14} />} onClick={() => setHelpOpen(true)}>
      Help
    </Button>
  );
  return (
    <ProjectShell>
      <GheIxTablesTab actions={helpButton} />
      <HelpWindow topics={gheHelpTopics} open={helpOpen} onClose={() => setHelpOpen(false)} />
    </ProjectShell>
  );
};

export default IxTablesPage;
